import { useFormikContext } from 'formik';

import { Button, ButtonProps } from '../../Button/button.component';

export const CancelButton: React.FC<ButtonProps> = ({ ...props }) => {
  const formikContext = useFormikContext();

  return (
    <Button
      disabled={formikContext.isSubmitting}
      variant="text"
      data-testid="cancel-button"
      {...props}
    />
  );
};
